// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import '@atlassian/jira-portfolio-3-common/src/css-variables/variables.css';
import React, { useState } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { FormattedMessage } from '@atlassian/jira-intl';
import { FeedbackButtonLazyComponent } from '@atlassian/jira-portfolio-3-feedback-collector/src/ui/async.tsx';
import AssociatedIssuesWrapper from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/associated-issues-provider/index.tsx';
import FlagGroup from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/flag-group/index.tsx';
import type { Props } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/types.tsx';
import RoadmapWrapper from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/roadmap-wrapper/index.tsx';
import HeaderToggle from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/page-header/header-toggle/index.tsx';
import type { HeaderMode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/page-header/header-toggle/types.tsx';
import PageHeader from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/page-header/index.tsx';
import Toolbar from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/page-header/toolbar/index.tsx';
import Scenarios from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/title-bar/scenarios/index.tsx';
import ShareReport from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/top/title-bar/share-report/index.tsx';
import { TIMELINE_SHARE_TYPE } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { ReportAppBase } from '../../common/ui/app-base/index.tsx';
import messages from './messages.tsx';

const HeaderBar = () => {
	const [headerMode, setHeaderMode] = useState<HeaderMode>('visible');

	return (
		<>
			{headerMode !== 'hidden' && (
				<HeaderContent>
					{headerMode !== 'toolbar' && (
						<PageHeader
							title={<FormattedMessage {...messages.timeline} />}
							titleDecorators={<Scenarios />}
							actions={
								<>
									<FeedbackButtonLazyComponent />
									<ShareReport confluenceMacroType={TIMELINE_SHARE_TYPE} />
								</>
							}
							showPlanTitle
						/>
					)}
					<Toolbar />
				</HeaderContent>
			)}
			<HeaderToggle mode={headerMode} setMode={setHeaderMode} />
		</>
	);
};

const PlanReport = (props: Props) => (
	<UFOSegment name="plan-report-app">
		<ReportAppBase withReduxStore paddingRight={false} paddingLeft={false}>
			<AssociatedIssuesWrapper>
				<HeaderContainer>
					<HeaderBar />
				</HeaderContainer>
				<RoadmapContainer>
					<RoadmapWrapper {...props} />
				</RoadmapContainer>
				<FlagGroup />
			</AssociatedIssuesWrapper>
		</ReportAppBase>
	</UFOSegment>
);

export default PlanReport;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const RoadmapContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderTop: `1px solid ${token('color.border')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderLeft: `1px solid ${token('color.border')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderTopLeftRadius: `${gridSize / 2}px`,
	position: 'relative',
	flex: 1,
	display: 'flex',
	marginLeft: token('space.300'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderContainer = styled.div({
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	paddingLeft: token('space.300'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderContent = styled.div({
	paddingTop: token('space.300'),
	paddingRight: token('space.300'),

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > div': {
		marginTop: 0,
	},
});
